import React from "react";
import Hero from "./hero";
import Contact from "./Contact";
import Facts from "./facts";
import Portfolio from "./Portfolio";
import Resume from "./Resume";
import Skills from "./Skills";
import Services from "./Services";
import Testimonials from "./Testimonials";
import About from "./About";
import Header from "./Header";
import Footer from "./Footer";

const Main = () => {
  return (
    <main id="main">
      <Hero />
      <Header />
      <About />
      <Facts />
      <Skills />
      <Resume />
      <Portfolio />
      <Services />
      <Testimonials />
      <Contact />
      <Footer />
    </main>
  );
};
export default Main;
